import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Idle } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';
import { OKTA_AUTH } from '@okta/okta-angular';
import OktaAuth from '@okta/okta-auth-js';
import { firstValueFrom } from 'rxjs';
import { ConfigService } from './config.service';
import { NotificationsService } from './notifications.service';
import { UsersService } from './users.service';

@Injectable()
export class AuthService {

  publicPath: string;
  revokePath: string;

  constructor(@Inject(OKTA_AUTH) public oktaAuth: OktaAuth, private configService: ConfigService,
    private httpClient: HttpClient, private router: Router, private usersService: UsersService,
    private notificationsService: NotificationsService, private idle: Idle, private keepalive: Keepalive) {
    this.publicPath = this.configService.appConfig.apic.baseUrl + this.configService.appConfig.apic.publicPath;
    this.revokePath = this.configService.appConfig.apic.baseUrl + this.configService.appConfig.apic.revokePath;
  }

  checkUser(navigateOnLogout: boolean): Promise<any> {
    return this.usersService
      .ptk()
      .then((connection) => {
        if (connection.connected && connection.userValid && connection.idMatchesUser) {
           return true;
        } else if (connection.connected && connection.userValid) {
          return true;
        } else {
          this.signOut();
          return false;
        }
      })
      .catch((err) => {
        return false;
      });
  }

  public signOut(): void {
    this.notificationsService.clearAll(); // clear all modal when timeout
    this.keepalive.stop();
    this.idle.stop();

    this.httpClient.delete(this.publicPath + this.configService.appConfig.api.baseUrl + '/signout'); // Clear PAYER-X-TOKEN
    this.oktaAuth.revokeAccessToken();
    this.oktaAuth.closeSession();
    firstValueFrom(this.httpClient.delete(this.revokePath)).then(() => { // revoke APIC session
      this.router.navigate(['/']);
    });
  }
}
